import { api, axiosInstance } from './api';
import { AxiosResponse } from 'axios';

interface LoginCredentials {
  email: string;
  password: string;
}

interface ForgotPasswordData {
  email: string;
}

export interface AuthError {
  message: string[];
  error: string;
  statusCode: number;
}

export const auth = {
  login: async (credentials: LoginCredentials): Promise<void> => {
    try {
      await api.post('/auth/login', credentials);
    } catch (error) {
      const authError = error as AuthError;
      throw authError;
    }
  },

  logout: async (): Promise<void> => {
    try {
      await api.post('/auth/logout', {});
    } catch (error) {
      const authError = error as AuthError;
      throw authError;
    }
  },

  refresh: async (): Promise<AxiosResponse> => {
    try {
      const response = await axiosInstance.post(
        '/auth/refresh',
        {},
        {
          skipAuthRefresh: true,
        }
      );
      if (response.status === 200 || response.status === 201) {
        return response;
      }
      throw new Error('Refresh failed');
    } catch (error) {
      const authError = error as AuthError;
      throw authError;
    }
  },

  getUser: async (): Promise<{ isAuthenticated: boolean; responseBody?: any }> => {
    try {
      const response = await axiosInstance.get('/auth/me', {
        skipAuthRefresh: true,
      });
      return { isAuthenticated: true, responseBody: response.data };
    } catch (error) {
      return { isAuthenticated: false };
    }
  },

  hasRefreshToken(): boolean {
    return document.cookie.includes('refreshToken=');
  },

  forgotPassword: async (data: ForgotPasswordData): Promise<void> => {
    try {
      await api.post('/auth/forgot-password', data);
    } catch (error) {
      const authError = error as AuthError;
      throw authError;
    }
  },
};
